<div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable" role="document" style="max-width:960px;">
	<div class="modal-content">
		<div class="modal-header">
			<h5 class="modal-title">Telephely adatai</h5>
			<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
		</div>
		<div class="modal-body">
			<%- include('/ui/form', {
				params: [ 'site', site ],
				fields: [
					{ type: 'row', fields: [
						{ type: 'col', fields: [
							{
								type: 'select',
								name: 'type',
								title: 'Típus',
								params: {
									options: Anvil.models.c_order.Site.Types,
									render: {
										item: (item, esc) => `<div><i class="fa fa-fw fa-${item.icon} me-2"></i>${esc(item.label)}<br /></div>`,
										option: (item, esc) => `<div class="option"><i class="fa fa-fw fa-${item.icon} me-2"></i>${esc(item.label)}</div>`
									}
								}
							},
							{
								type: 'text',
								name: 'public_name',
								title: 'Fantázia név',
								help: '<i class="fa fa-sm fa-info-circle me-2"></i>Ez az üzlet közösségi neve, amelyen a vendégek ismerik.'
							}
						]},
						{ type: 'col', fields: [
							{
								type: 'text',
								name: 'name',
								title: 'Név (c-Store)',
								attributes: {
									readonly: true,
									disabled: true
								}
							}
						]}
					]},
					{
						type: 'html',
						content: '<hr />'
					},
					{ type: 'row', fields: [
						{ type: 'col', fields: [
							{
								type: 'text',
								name: 'area_code',
								title: 'Irányítószám'
							},
							{
								type: 'text',
								name: 'city',
								title: 'Város'
							},
							{
								type: 'text',
								name: 'address',
								title: 'Utca, házszám'
							},
							{
								type: 'text',
								name: 'location_name',
								title: 'Hely neve',
								help: '<i class="fa fa-sm fa-info-circle me-2"></i>Ez lehet egy bevásárlóközpont neve, vagy egyéb elnevezés, amely segíti a helyszín azonosítását.',
								attributes: {
									placeholder: 'pl.: Árkád, Tesco, Auchan, stb.'
								}
							},
							{
								type: 'html',
								content: '<div class="form-group row"><div class="col-4"></div><div class="col text-center"><button type="button" class="btn btn-primary" onclick="Anvil.page.modal.geocode()"><i class="fa fa-search-location me-2"></i>Koordináták keresése cím alapján</button></div></div>'
							},
							{
								type: 'geo_coords',
								name: 'geo_coords',
								title: 'Koordináták'
							}
						]},
						{ type: 'col', fields: [
							{
								type: 'geo_picker',
								name: 'geo_coords',
								title: 'Koordináták',
								inline: true,
								height: 311,
								styles: Anvil.models.c_order.Site.Types,
								style_field: 'type'
							}
						]}
					]}
				]
			}) %>
		</div>
		<div class="modal-footer justify-content-between">
			<div>
				<div class="dropup float-start me-1">
					<button class="btn btn-dark" data-bs-toggle="dropdown" data-bs-auto-close="outside"><i class="fa fa-fw fa-caret-up"></i></button>
					<ul class="dropdown-menu">
						<li><button type="button" class="dropdown-item py-2" onclick="Anvil.page.modal.close(); Anvil.exec('company/modal_edit', <%- site.company_id %>)"><i class="fa fa-fw fa-building me-3"></i><%- site.company_name %></button></li>
						<li><button type="button" class="dropdown-item py-2" onclick="Anvil.page.modal.close(); Anvil.exec('c_order/company_db/modal_edit', <%- site.company_db_id %>)"><i class="fa fa-fw fa-database me-3"></i><%- site.company_db_name %></button></li>
						<li><button type="button" class="dropdown-item py-2 disabled"><i class="fa fa-fw fa-<%- Anvil.models.c_order.Site.Types.find(t => t.value == site.type).icon %> me-3"></i><%- site.public_name || site.name %></button></li>
					</ul>
				</div>
				<button type="button" class="btn btn-dark" style="color:tan;" onclick="Anvil.page.modal.issue()"><i class="fa fa-briefcase me-2"></i>Új munkalap</button>
			</div>
			<button type="button" class="btn btn-primary" onclick="Anvil.page.modal.save()"><i class="fa fa-save me-2"></i>Mentés</button>
		</div>
	</div>
</div>
<script>
Anvil.page.modal = Object.assign(Anvil.page.modal, {

	init () {
		[ geo_picker ] = Anvil.models.components.Component.findAllOfType('GeoPicker')
		geo_picker.refresh()
	},

	async geocode () {
		const site = Anvil.page.modal.site
		const address = `${site.area_code} ${site.city} ${site.address}`
		const res = await Anvil.exec('c_order/site/action_geocode', address)
		if (res) {
			if (res.type == 'FeatureCollection' && Array.isArray(res.features) && res.features.length > 0) {
				site.geo_coords = [ res.features[0].properties.lat, res.features[0].properties.lon ]
			}
		}
	},

	issue () {
		Anvil.page.modal.close()
		Anvil.exec('issue/modal_edit', null, {
			link: 'site',
			company_id: Anvil.page.modal.site.company_id,
			company_db_id: Anvil.page.modal.site.company_db_id,
			site_id: Anvil.page.modal.site.id
		})
	},

	async save () {
		const res = await Anvil.exec('c_order/site/action_save', Anvil.page.modal.site)

		if (res === true) {

			// Refresh list
			if ('refresh' in Anvil.page) {
				Anvil.page.refresh()
			}

			// Focus on company
			/*
			let grid = Anvil.models.components.Grid.find('#site_grid')
			grid.select(grid.list.getById(Anvil.page.modal.site.id), true)
			*/

			// Close modal
			Anvil.page.modal.close()
		}
	}
})
</script>
